import type { FC } from 'react';
import DefaultBatchEdit from '../../../../components/batchActions/DefaultBatchEdit';
import TitleBatchEdit from '../../../../components/batchActions/TitleBatchEdit';
import TagsBatchEdit from '../../../../components/batchActions/TagsBatchEdit';
import DescriptionBatchEdit from '../../../../components/batchActions/DescriptionBatchEdit';
import GalleryBatchEdit from '../../../../components/batchActions/GalleryBatchEdit';
import TierBatchEdit from '../../../../components/batchActions/TierBatchEdit';
import LicenseBatchEdit from '../../../../components/batchActions/LicenseBatchEdit';
import CommentsBatchEdit from '../../../../components/batchActions/CommentsBatchEdit';
import LabelsBatchEdit from '../../../../components/batchActions/LabelsBatchEdit';
import ScheduleBatch from '../../../../components/batchActions/ScheduleBatch';
import DisplayOptionsBatchEdit from '../../../../components/batchActions/DisplayOptionsBatchEdit';
import PresetBatchEdit from '../../../../components/batchActions/PresetBatchEdit';
import { BatchAction } from '../../../../types/store';

export interface Props {
  batchAction: BatchAction;
}

const BatchActionForm: FC<Props> = ({ batchAction }) => {
  switch (batchAction) {
    case BatchAction.EDIT_TITLE:
      return <TitleBatchEdit />;
    case BatchAction.EDIT_TAGS:
      return <TagsBatchEdit />;
    case BatchAction.EDIT_DESCRIPTION:
      return <DescriptionBatchEdit />;
    case BatchAction.EDIT_GALLERY:
      return <GalleryBatchEdit />;
    case BatchAction.EDIT_TIER:
      return <TierBatchEdit />;
    case BatchAction.EDIT_SCHEDULE:
      return <ScheduleBatch />;
    case BatchAction.EDIT_LICENSE:
      return <LicenseBatchEdit />;
    case BatchAction.EDIT_COMMENTS:
      return <CommentsBatchEdit />;
    case BatchAction.EDIT_LABELS:
      return <LabelsBatchEdit />;
    case BatchAction.EDIT_DISPLAY_OPTIONS:
      return <DisplayOptionsBatchEdit />;
    case BatchAction.EDIT_PRESET:
      return <PresetBatchEdit />;
    default:
      return <DefaultBatchEdit />;
  }
};
BatchActionForm.displayName = 'BatchActionForm';

export default BatchActionForm;
